<template>
    <div>
         <div class="d-flex flex-wrap">
            <div class="card mr-3" style="width: 230px;">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fa-solid fa-sack-dollar"></i></span>
                    <h6 class="mb-0 font-weight-semibold">{{ $t("Money transferred") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">฿{{amount | formatNumber}}</h3>
                </div>
            </div>
            <div class="card mr-3" style="width: 230px;">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fa-solid fa-clipboard-list"></i></span>
                    <h6 class="mb-0 font-weight-semibold"> {{ $t("Number of parcels") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">{{percels}}</h3>
                </div>
            </div>
            <div class="card mr-3" style="width: 230px;">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fa-solid fa-file-invoice"></i></span>
                    <h6 class="mb-0 font-weight-semibold">  {{ $t("Billing No.") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">{{billingNo}}</h3>
                </div>
            </div>
             <div class="card mr-3" style="width: 230px;">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fa-solid fa-calendar-days"></i></span>
                    <h6 class="mb-0 font-weight-semibold">   {{ $t("Execution Date") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">{{excuteDate}}</h3>
                </div>
            </div>
             <div class="card mr-3" style="width: 230px;" v-if="transferDate != ''">
                <div class="card-body">
                    <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fa-solid fa-calendar-days"></i></span>
                    <h6 class="mb-0 font-weight-semibold">   {{ $t("Transfer Date (Estimate)") }}</h6>
                    <h3 class="text-grey-800 font-weight-semibold my-1">{{transferDate}}</h3>
                </div>
            </div>

        </div>
    </div>
    <!-- <div class="row pl-3 pr-3">
        <div class="col-12 col-sm-6 col-xl-4">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div>
                            <div class="m-0 text-grey-300 text-uppercase">
                               {{ $t("Money transferred") }}
                            </div>
                            <h2 class="text-grey-800">
                                ฿{{amount}}
                            </h2>
                        </div>
                        <div class="ml-auto btn bg-primary rounded-round btn-icon">
                            <span class="letter-icon"><i class="fa-solid fa-sack-dollar"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-4">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div>
                            <div class="m-0 text-grey-300 text-uppercase">
                                {{ $t("Number of parcels") }}
                            </div>
                            <h2 class="text-grey-800">
                                {{percels}}
                            </h2>
                        </div>
                        <div class="ml-auto btn bg-primary rounded-round btn-icon">
                            <span class="letter-icon"><i class="fa-solid fa-clipboard-list"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-4">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div>
                            <div class="m-0 text-grey-300 text-uppercase">
                                {{ $t("Billing No.") }}
                            </div>
                            <h2 class="text-grey-800">
                              {{billingNo}}
                            </h2>
                        </div>
                        <div class="ml-auto btn bg-primary rounded-round btn-icon">
                            <span class="letter-icon"><i class="fa-solid fa-file-invoice"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-4 mt-2">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div>
                            <div class="m-0 text-grey-300 text-uppercase">
                                {{ $t("Execution Date") }}
                            </div>
                            <h2 class="text-grey-800">
                                {{excuteDate}}
                            </h2>
                        </div>
                        <div class="ml-auto btn bg-primary rounded-round btn-icon">
                            <span class="letter-icon"><i class="fa-solid fa-calendar-days"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6 col-xl-4 mt-2" v-if="transferDate != ''">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="d-flex align-items-start">
                        <div>
                            <div class="m-0 text-grey-300 text-uppercase">
                                {{ $t("Transfer Date (Estimate)") }}
                            </div>
                            <h2 class="text-grey-800">
                               {{transferDate}}
                            </h2>
                        </div>
                        <div class="ml-auto btn bg-primary rounded-round btn-icon">
                            <span class="letter-icon"><i class="fa-solid fa-calendar-days"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</template>

<script>
    import Api from "@/services/endpoint/tenant.service";
    import DateRangePicker from "vue2-daterange-picker";
    import PerPage from "../PerPage.vue";
    import Select2 from "v-select2-component";
    import moment from "moment";
    import VueJsCounter from "@/plugins/VueJsCounter";
    import numeral from "numeral";
    import {
        convertTimezone
    } from "@/common/tenancy/convertTimezone";
    import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
    export default {
        name: "detail",
        components: {
            DateRangePicker,
            PerPage,
            Select2,
            PlaceholderContent,
            VueJsCounter
        },
        data() {
            return {
                onload: false,
                isLoaded: true,
                billingNo:'',
                amount: '',
                percels: '',
                excuteDate:'',
                transferDate:'',
                since_text: "Since last month",
                duration: 2000,
            };
        },
        computed: {

        },
        methods: {
             getOverviews: async function(){
                let id = this.$route.params.id;
                const codAccountId = this.$route.params.cod_account_id; 
                await Api.Report.getCodReconcileOverViews(id, codAccountId).then((res) => {
                    this.amount =  res.amount_total ? numeral(res.amount_total).format("0,0.00") : '-';
                    this.percels =  res.qty_prac ? res.qty_prac : '-';
                    this.billingNo = res.billing_no ? res.billing_no : '-';
                    this.excuteDate =  res.create_date ? convertTimezone.utcToLocal(res.create_date) : '-';
                    this.transferDate =  res.estimate_date ? convertTimezone.utcToLocalDate(res.estimate_date) : '';
                }).catch((error) => {
                    if (error.response.status == 403) {
                        this.$parent.hasPermission = true;
                    } else {
                        this.$router.push({name: "t.a.home"});
                        console.log(error.response, 'error');
                    }
                });
            }
        },
        async mounted() {
            this.getOverviews();
        },
        filters: {
            formatNumber: function (value) {
                if (value == '-') {
                    value = 0;
                }
                return numeral(value).format("0,0.00");
            },
        },
    };

</script>
<style>
    .header-title {
        margin-bottom: 0.1rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/OverviewDetail.vue